import React, { useContext, useMemo } from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { CommentContext } from '../../CommentContext';
import AuthorUserLink from '../AuthorUserLink';
import CommentTimestamp from '../CommentTimestamp';
import FeaturedTag from '../FeaturedTag';
import { extractExclusiveAvatarDeviation } from '../../utils';
import s from './BylineBlock.scss';

interface Props {
  className?: string;
}

/**
 * A user link, a timestamp, and a "Featured" tag if the comment is featured.
 *
 * We tend to add this just before the text content of a comment.
 * */
const BylineBlock: React.FC<Props> = ({ className }) => {
  const { comment } = useContext(CommentContext);
  const { isFeatured, user } = comment;
  const exclusive_avatars = useFlag('exclusive_avatars');

  const exclusiveAvatarDeviation = useMemo(() => {
    if (!exclusive_avatars) return undefined;
    return extractExclusiveAvatarDeviation(comment);
  }, [comment, exclusive_avatars]);

  return (
    <div className={c(s['root'], className)}>
      {exclusiveAvatarDeviation ? (
        <span className={c(s['userlink'], s['deviation-title'])}>
          {exclusiveAvatarDeviation.title}
        </span>
      ) : (
        user && <AuthorUserLink comment={comment} className={s['userlink']} />
      )}
      <CommentTimestamp className={s['timestamp']} />
      {isFeatured && <FeaturedTag />}
    </div>
  );
};
BylineBlock.displayName = 'BylineBlock';

export default BylineBlock;
